<template lang="pug">
  .flex.justify-center.mx-auto.pb-4(:class="scrolled ? 'md:shadow-bottom' : 'shadow-none'")
    slot
</template>

<script>
import { scrollListener } from '../../mixins/scrollListener';

export default {
  name: 'SwProgressTracker',
  mixins: [scrollListener],
  data () {
    return {
      offset: this.$screen.lg ? 248 : 0,
    };
  },
  created () {
    this.addScrollListener(this.offset);
  },
  beforeDestroy () {
    this.removeScrollListener(this.offset);
  },
};
</script>
